/*! JointJS+ v4.0.1 - HTML5 Diagramming Framework

Copyright (c) 2024 client IO

 2024-04-11 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import {
    AVALIATION_ICON,
    CONDITON_ICON,
    CREATE_TICKET_ICON,
    ENTITY_ICON,
    FLOW_ICON,
    LLM_ICON,
    MESSAGE_ICON,
    RESPONSE_PARAM_ICON,
    TALK_ATTENDANT_ICON,
    USER_INPUT_ICON
} from '../../theme';

export const stencilConfig = {
    shapes: [
        {
            name: 'FlowchartStart',
            attrs: {
                label: { text: 'Início' },
            }
        }, 
        {
            name: 'FlowchartEnd',
            attrs: {
                label: { text: 'Fim' },
            }
        }, 
        {
            name: 'Message',
            attrs: {
                label: { text: 'Resposta de opções' },
                icon: { xlinkHref: USER_INPUT_ICON }
            }
        }, {
            name: 'Service',
            attrs: {
                label: { text: 'Resposta serviço' },
                icon: { xlinkHref: ENTITY_ICON }
            }
        }, 
        {
            name: 'ResponseParam',
            attrs: {
                label: { text: 'Resposta parâmetro' },
                icon: { xlinkHref: RESPONSE_PARAM_ICON }
            }
        }, 
        {
            name: 'ResponseOrientation',
            attrs: {
                label: { text: 'Resposta orientação' },
                icon: { xlinkHref: MESSAGE_ICON }
            }
        },
        {
            name: 'TalkAttendant',
            attrs: {
                label: { text: 'Falar com atendente' },
                icon: { xlinkHref: TALK_ATTENDANT_ICON }
            }
        },
        {
            name: 'Flow',
            attrs: {
                label: { text: 'Fluxos' },
                icon: { xlinkHref: FLOW_ICON }
            }
        },
        {
            name: 'CreateTicket',
            attrs: {
                label: { text: 'Criar ticket' },
                icon: { xlinkHref: CREATE_TICKET_ICON }
            }
        },
        {
            name: 'Avaliation',
            attrs: {
                label: { text: 'Avaliação' },
                icon: { xlinkHref: AVALIATION_ICON }
            }
        },
        {
            name: 'LLM',
            attrs: {
                label: { text: 'LLM' },
                icon: { xlinkHref: LLM_ICON }
            }
        },
        // F7 POC — caixa Condicional habilitada no stencil (era placeholder comentado).
        {
            name: 'Condition',
            attrs: {
                label: { text: 'Condição' },
                icon: { xlinkHref: CONDITON_ICON }
            }
        },
        // Item #1 roadmap chatbot (06/10/2026) — SetVariable.
        // Fix 08/10: ícone próprio (gear/settings MDI) definido no stencil.shapes.ts
        // (antes usava CONDITON_ICON, confundia com Condition — regra ícones distintos).
        {
            name: 'SetVariable',
            attrs: {
                label: { text: 'Setar variável' }
            }
        },
        // Item #2 roadmap chatbot (07/10/2026) — Tag: classifica a conversa aplicando tags.
        // Ícone definido no stencil.shapes.ts (TAG_ICON_SVG, label/tag MDI).
        {
            name: 'Tag',
            attrs: {
                label: { text: 'Tag' }
            }
        },
        // Item #2 roadmap chatbot (07/10/2026) — Note: cria nota interna no chat.
        // Ícone definido no stencil.shapes.ts (NOTE_ICON_SVG, sticky-note MDI).
        {
            name: 'Note',
            attrs: {
                label: { text: 'Nota' }
            }
        },
        // Item #3 roadmap chatbot (07/10/2026) — Business Hours: expediente + feriados do hirer.
        // Ícone definido no stencil.shapes.ts (BUSINESS_HOURS_ICON_SVG, relógio MDI).
        {
            name: 'BusinessHours',
            attrs: {
                label: { text: 'Horário' }
            }
        },
        // Item #7 roadmap chatbot (08/10/2026) — Native Action (YOLO): executa ações nativas do Mexx.
        // Ícone bolt (ação instantânea) definido no stencil.shapes.ts.
        {
            name: 'NativeAction',
            attrs: {
                label: { text: 'Ação Nativa' }
            }
        },
        // Item #7 Fase 2 (08/10/2026) — Lista Interativa (pausável, estreia Fundação #0).
        // Renderiza array e aguarda escolha do cliente. Ícone lista numerada MDI distinto.
        {
            name: 'InteractiveList',
            attrs: {
                label: { text: 'Lista Interativa' }
            }
        }
    ]
};